import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "font-bold" }

import { Button } from '@/components/ui/button';
    import {
        Dialog,
        DialogContent,
        DialogHeader,
        DialogTitle,
        DialogClose,
        DialogFooter,
        DialogBody,
    } from '@/components/ui/dialog';
    import { computed, ref, watch } from 'vue';
    import { useI18n } from 'vue-i18n';
    import FileUploadZone from '../FileUploadZone.vue';
    import type { Payslip } from '@/types';
    import axios from 'axios';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { Checkbox } from '@/components/ui/form';
    import { useQueryClient } from '@tanstack/vue-query';
    import QueryKey from '@/enums/QueryKey';
    import { toast } from 'vue-sonner';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PayslipUpload',
  props: {
    payslip: {},
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const open = computed({
        get: () => props.modelValue ?? false,
        set: (value) => emit('update:modelValue', value),
    });

    const { t } = useI18n();

    const page = usePage<SharedData>();
    const selectedCompanyName = computed(() => page.props.auth.user.selected_company_name);
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const uploadedFile = ref([]);
    const consent = ref(false);

    const queryClient = useQueryClient();

    const handleClose = () => {
        uploadedFile.value = [];
        consent.value = false;
        open.value = false;
    };

    const handleFileDelete = async () => {
        await axios.post(route('v2.salary.payslip.delete'), { id: props.payslip.id });
    };

    const handleSuccess = () => {
        toast.success(t('forms.general.success'));
    };

    watch(open, (newVal) => {
        if (!newVal) {
            queryClient.invalidateQueries({
                queryKey: [QueryKey.PAYROLLS, selectedCompanyId.value],
            });
        }
    });

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: open.value,
    "onUpdate:open": _cache[2] || (_cache[2] = (value) => (open.value = value))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "sm:max-w-lg" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('pay-slips.headers.upload')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogBody), { class: "space-y-5" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Checkbox), {
                id: "consent",
                modelValue: consent.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((consent).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_i18n_t, {
                    keypath: "pay-slips.upload_consent",
                    tag: "span",
                    scope: "global"
                  }, {
                    name: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, _toDisplayString(selectedCompanyName.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (consent.value)
                ? (_openBlock(), _createBlock(FileUploadZone, {
                    key: 0,
                    modelValue: uploadedFile.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((uploadedFile).value = $event)),
                    ref: "uploadZoneRef",
                    "instant-upload": "",
                    route: _ctx.route('v2.salary.payslip.upload'),
                    "additional-fields": {
                        id: _ctx.payslip.id,
                    },
                    "max-uploads": 1,
                    "delete-file": handleFileDelete,
                    onSuccess: handleSuccess
                  }, null, 8, ["modelValue", "route", "additional-fields"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogClose), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    variant: "outline",
                    size: "sm",
                    onClick: handleClose
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('forms.close')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})